// extracted by mini-css-extract-plugin
export default {"section":"MatchLearnerPage_section__IW1ll","eyebrow":"MatchLearnerPage_eyebrow__ToPko"};